import { type FC } from 'react';
import { optionalProp } from '../../core';
import { MLPVersion } from '../../types/enums';
import DropDown from '../../DropDown/DropDown';
import Input, { InputTypes } from '../../Input/Input';
import { type PhoneNumberMLPProps } from '../types/propsType';
import styles from '../PhoneNumber.module.scss';

/**
 *
 *  by default : disabledFilter, dropdownDisabled, inputDisabled is false;
 *  name is required prop
 */

const PhoneNumberMLP2: FC<PhoneNumberMLPProps> = ({
  name,
  dropdownLabel = '',
  dropdownValue = '',
  disabledFilter = false,
  dropdownDisabled,
  hideDropdown = false,
  configData,
  inputType = InputTypes.NUMBER,
  inputLabel = '',
  inputValue = '',
  inputDisabled = false,
  onInputChange,
  status,
  onBlur,
  onMouseOver,
  onFocus,
  onMouseLeave,
  phoneCountryData,
  isElementFocused,
  isHovered,
  setIsElementFocused,
  setIsHovered,
  onChange,
  inputWithDropdown = false,
  dropdownValidity,
  ...restProps
}): JSX.Element => {
  const isOnlyEntry = phoneCountryData?.length === 1;
  return (
    <section
      className={`${styles['phone-number-body']} ${inputWithDropdown ? styles['input-with-dropdown'] : ''} ${
        isHovered ? styles['element-ishovered'] : ''
      } ${isElementFocused ? styles['element-isfocused'] : ''} ${hideDropdown ? styles['hide-dropdown'] : ''}`}
    >
      <span
        className={`${styles['dropdown-number']}  ${inputWithDropdown ? styles['input-with-dropdown'] : ''} ${
          dropdownDisabled ? styles['disable-dropdown'] : ''
        } ${isOnlyEntry ? styles['is-only-entry'] : ''} ${status ? styles[status] : ''}`}
      >
        <DropDown
          data-testid="number-dropDown"
          disabled={dropdownDisabled}
          name={name}
          value={dropdownValue as string}
          dropdownLabel={dropdownLabel}
          disabledFilter={disabledFilter}
          onBlur={onBlur}
          drawerParentOutside
          mlpVersion={inputWithDropdown ? MLPVersion.ONE : MLPVersion.TWO}
          {...optionalProp('configData', configData)}
          {...optionalProp('data', phoneCountryData)}
          {...optionalProp('status', inputWithDropdown ? dropdownValidity : undefined)}
        />
      </span>
      <span
        className={`${styles['input-number']} ${
          inputWithDropdown ? styles['input-with-dropdown'] : styles['input-number-outline']
        } ${inputDisabled ? styles['disable-input'] : ''}`}
      >
        <Input
          data-testid="input-number"
          {...optionalProp('status', inputWithDropdown ? status : undefined)}
          inputWithDropdown={inputWithDropdown}
          label={inputLabel}
          name={name}
          value={inputValue}
          type={inputType}
          disabled={inputDisabled}
          readOnly={inputDisabled}
          mlpVersion={inputWithDropdown ? MLPVersion.ONE : MLPVersion.TWO}
          onMouseOver={(e) => {
            !inputDisabled && setIsHovered(true);
            onMouseOver && onMouseOver(e);
          }}
          onMouseLeave={(e) => {
            setIsHovered(false);
            onMouseLeave && onMouseLeave(e);
          }}
          onFocus={(e) => {
            !inputDisabled && setIsElementFocused(true);
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            setIsElementFocused(false);
            onBlur && onBlur(e);
          }}
          onChange={(e) => {
            onChange?.(e);
            onInputChange?.(e.target.value, status, e);
          }}
          {...restProps}
        />
      </span>
    </section>
  );
};
export default PhoneNumberMLP2;
